import React from "react";

const ArticleNotInterressedModal = ({article, confirmNotInterested, setShowPlusInteresseModal}) => {
  return (
    <>
      {/* Article Not Interested Modal */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">N'est plus intéressé</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                    setShowPlusInteresseModal(false)}
                }
              ></button>
            </div>
            <div className="modal-body">
              <p>Êtes-vous sûr de ne plus être intéressé par cette annonce ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => {
                    setShowPlusInteresseModal(false)}
                }
              >
                Annuler
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  confirmNotInterested(article._id);
                  setShowPlusInteresseModal(false);
                }}
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ArticleNotInterressedModal;
